module.exports = __webpack_public_path__ + "img/02.620c191b.jpg";